export default "__VITE_ASSET__D3Q6_VfW__"